import {
  BACKGROUND_MOVED,
  BACKGROUND_SCALE,
  BACKGROUND_TRANSFORMED,
  NEW_BACKGROUND_REQUESTED,
  SHOW_BACKGROUND_MOVED_TRANSFORMED,
  SHOW_BACKGROUND_MULTIBED_WARNING,
  UPDATE_MULTIBED_SCALE
} from "../lib/types";

/* BACKGROUND ACTIONS */
export const backgroundMoved = coordinates => dispatch => {
  dispatch({
    type: BACKGROUND_MOVED,
    payload: coordinates
  });
};

export const backgroundTransformed = transformations => dispatch => {
  dispatch({
    type: BACKGROUND_TRANSFORMED,
    payload: transformations
  });
};


export const setBackgroundScale = scale => dispatch => {
  dispatch({
    type: BACKGROUND_SCALE,
    payload: scale
  });
};

export const newBackgroundRequestedClick = ( value ) => ( dispatch ) => {
  dispatch({
    type: NEW_BACKGROUND_REQUESTED,
    payload: { newBackgroundRequestedByClick: value }
  });
};

export const showBackgroundMultiBedWarningDialog = ( value ) => ( dispatch ) => {
  dispatch({
    type: SHOW_BACKGROUND_MULTIBED_WARNING,
    payload: { showBackgroundMultiBedWarning: value }
  });
};

export const setBackgroundMovedTransformed = ( value ) => ( dispatch ) => {
  dispatch({
    type: SHOW_BACKGROUND_MOVED_TRANSFORMED,
    payload: { backgroundMovedTransformed: value }
  });
};



// WEBPACK FOOTER //
// ./src/actions/background-actions.js